module.exports = __webpack_public_path__ + "img/saomabaoxiu.b08bc2b2.png";